












































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { LocationTypes } from '@/types/LocationFilter';

@Component({})
export default class LocationListFilterBranchType extends Vue {
	@Prop({}) types!: Array<number>;

	numberOfChips = 2;

	readonly branchTypeOptions = [
		{'value': LocationTypes.VALUE_ATM, 'text': 'ATM'},
		{'value': LocationTypes.VALUE_BRICK, 'text': 'Branch'},
		{'value': LocationTypes.VALUE_BRICK_ATM, 'text': 'Branch + ATM'},
	];

	set selected(value: Array<number>) {
		this.$emit('updatetypes', value);
	}

	get selected() {
		return this.types;
	}

	doSelectAll() {
	if (this.types.length) {
		this.$emit('updatetypes', []);
		return;
	}

	const types = this.branchTypeOptions.map((option) => {
		return option.value;
	});
	this.$emit('updatetypes', types);
	}

	get selectAllIcon() {
		// checked
		if (this.selected && this.selected.length ===  this.branchTypeOptions.length) {
			return 'fas fa-check-square';
		}

		// partially checked
		if (this.selected && this.selected.length > 0) {
			return 'fas fa-minus-square';
		}

		// unchecked
		return 'far fa-square';
	}

	get selectAllColor() {
		// checked
		if (this.selected && this.selected.length === this.branchTypeOptions.length) {
			return 'indigo darken-4';
		}

		// partially checked
		if (this.selected && this.selected.length > 0) {
			return 'indigo darken-4';
		}

		// unchecked
		return 'grey';
	}
}
